import React from 'react';
import { Box, HStack, Icon, SimpleGrid, Skeleton, Stack, Text } from '@chakra-ui/react';
import { MdStars, MdDomain, MdVerifiedUser, MdPublic } from 'react-icons/md';
import Container from '../ui/Container';
import useFetch from '../../hooks/useFetch';
import { getProjects } from '../../lib/api';
import { BRANDS } from '../../data/brands';
import site from '../../config/site';

function Indicator({ icon, value, label, isLoading, showDivider }) {
  return (
    <HStack
      spacing={4}
      px={{ base: 0, lg: 3 }}
      borderLeft={{ base: 'none', lg: showDivider ? '1px solid' : 'none' }}
      borderColor="border.default"
      align="center"
      minW={0}
      w="100%"
    >
      <Icon as={icon} boxSize={{ base: 8, md: 9 }} color="accent.default" flexShrink={0} aria-hidden="true" />
      <Box minW={0} flex={1}>
        {isLoading ? (
          <Skeleton height="28px" width="60px" mb={1} />
        ) : (
          <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight={700} lineHeight={1.1}>
            {value}
          </Text>
        )}
        <Text fontSize="xs" color="text.secondary">
          {label}
        </Text>
      </Box>
    </HStack>
  );
}

export default function TrustIndicators() {
  const { data: projects, isLoading } = useFetch(getProjects, []);
  const years = new Date().getFullYear() - site.foundedYear;
  const projectCount = projects && Array.isArray(projects) && projects.length > 0 ? `${projects.length}+` : '10+';

  return (
    <Box
      as="section"
      position="relative"
      zIndex={2}
      mt={{ base: '-56px', md: '-64px', lg: '-40px' }}
      w="100%"
    >
      <Container>
        <Stack
          bg="surface.default"
          borderRadius="lg"
          boxShadow="md"
          border="1px solid"
          borderColor="border.default"
          px={{ base: 5, sm: 6, md: 8 }}
          py={{ base: 5, md: 6 }}
          w="100%"
          maxW="100%"
        >
          <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={{ base: 5, sm: 6, lg: 2 }} w="100%">
            <Indicator icon={MdStars} value={`${years}+`} label="Años de experiencia" />
            <Indicator
              icon={MdDomain}
              isLoading={isLoading}
              showDivider
              value={projectCount}
              label="Proyectos ejecutados"
            />
            <Indicator
              icon={MdVerifiedUser}
              value={`${BRANDS.length}`}
              label="Marcas representadas"
              showDivider
            />
            <Indicator icon={MdPublic} value="Panamá" label="Cobertura" showDivider />
          </SimpleGrid>
        </Stack>
      </Container>
    </Box>
  );
}
